(function () {
    angular.module('tradersyard').controller('webinar-query-ctrl', WebinarQueryCtrl);

    WebinarQueryCtrl.$inject = [
        '$rootScope',
        '$scope',
        'graph-webinar-factory',
        'webinar-query-filter',
        '$flex.scroll',
        '$window',
    ];

    /**
     *
     * @param {angular.IRootScopeService} $rootScope
     * @param $scope
     * @param $factory
     * @param $filter
     * @param $scroll
     * @param {angular.IWindowService} $window
     * @constructor
     */
    function WebinarQueryCtrl($rootScope, $scope, $factory, $filter, $scroll, $window) {
        const LIST_PRESENTATION_KEY = 'webinar.list-presentation';

        $scope.nodes = [];
        $scope.process = 0;
        $scope.space = 'me';
        $scope.groupMode = false;
        $scope.groupId = null;
        $scope.filter = $filter;

        $filter.on.change = function () {
            $scope.nodes = [];
            $scroll.renew('webinar');
            $scope.query();
        };

        $scope.$on('webinar-query-update', $filter.init);
        $scope.$on('$historyBack', $filter.init);

        // ========================================

        $scope.init = function (mode, groupId) {
            $scope.groupMode = mode === 'group';
            $scope.groupId = groupId;
        };

        $scope.$entry = function (space) {
            if (space) $scope.space = space;
        };

        $scope.presentation = localStorage.getItem(LIST_PRESENTATION_KEY) || 'list';

        $scope.changePresentation = function (presentation) {
            $scope.presentation = presentation;
            localStorage.setItem(LIST_PRESENTATION_KEY, presentation);
        };

        $scope.openRecurringDates = function (node) {
            $rootScope.$broadcast('open:reccuring-dates:modal', node);
        };

        $scope.openWebinar = function (id) {
            $window.location.href = `/webinar/${id}`;
        };

        $scope.query = function (next) {
            ++$filter.params.page;
            $scope.process = 1;

            const queryParams = angular.extend({}, $filter.params, {
                group_id: $scope.groupId,
            });

            $factory
                .query($scope.space, {
                    params: queryParams,
                })
                .then(function (response) {
                    if (response.data.state === 0 && response.data.data.length > 0) {
                        $scope.nodes = $scope.nodes.concat(response.data.data);

                        if (next) next();
                    }

                    $scope.process = 0;
                });
        };

        $scope.like = function (item) {
            $factory
                .likes(item.id)
                .like()
                .then(function (response) {
                    if (response.data.state === 0) {
                        item.im_like = true;
                        ++item.likes;
                    }
                });
        };

        $scope.unlike = function (item) {
            $factory
                .likes(item.id)
                .unlike()
                .then(function (response) {
                    if (response.data.state === 0) {
                        item.im_like = false;
                        --item.likes;
                    }
                });
        };
    }
})();
